let redirect = [
  {
    path: '/404',
    name: '404',
    component: () => import('@/components/redirect/404'),
    meta: {
      anonymous: true
    }
  },
  {
    path: '/401',
    name: '401',
    component: () => import('@/components/redirect/401')
  },
  {
    path: '/coding',
    name: 'coding',
    component: () => import('@/components/redirect/coding')
  },
  {
    path: '/message',
    name: 'message',
    component: () => import('@/components/redirect/Message.vue')
  },
  // sso登录:shaun:2025-10-23
  {
    path: '/sso/callback',
    name: 'ssoCallback',
    meta: { anonymous: true },
    component: () => import('@/components/redirect/SsoCallback.vue')
  },
  {
    path: '/sso/logout',
    name: 'ssoLogout',
    meta: { anonymous: true },
    component: () => import('@/components/redirect/SsoLogout.vue')
  }
];
export default redirect;
